/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http: HttpClient) { }

  GetFeeds(url: string): Observable<any> {
    const requestOptions: object = {
      observe: "body",
      responseType: "text"
    };
    const apiUrl = 'https://api.campconnectpro.ca/parseRSSFeed?url=';
    return this.http.get<any>(apiUrl + url, requestOptions);
  }
}
